class HxSearchResult {
    constructor(el){
        if(!el) return;
        this.el = {
            main: el,
            button: '.hx-result-rby-button',
            ioc: '.hx-block-title-ioc',
            clear: '.rby-clear',
            clearAll: '.rby-clearAll',
            page: '.hx-pagination .hx-pagination-list a',
            mButton: '.hx-search-mobile-button span',
            tooClose: '.hx-result-toolbar-close span',
            tooReturn: '.hx-result-rby-return',
            mClear: '.hx-result-rby-clear',
            mClearAll: '.hx-result-mClearAll',
            sortBy: '.hx-search-result-sort-by',
            dropdown: '.hx-search-result-filter-dropdown .lst a',
        };
        this._min = 0;
        this._max = 0;
        this.loadFlag = false;
        this._params = {};
        this._page = 1;
        this._sortBy = 'Sort by';
        this.selectedData = [];
        this.isMobile = $(window).width()>768?false:true;
        this.initEvent();
        this.initData();
        this.templateHtmlType = $(this.el.main).attr('rel');
        $(".breadcrumb").hide();
    };
    initEvent = () => {
        let _this = this;
        this._wrHistory(); //重写history，监听replaceState
        if(!this.isMobile){
            $(document).on('click', this.el.ioc, function(e){
                _this.toggleEvent($(this));
            });
            $(document).on('click', this.el.clear, this.clear);
            $(document).on('click', this.el.clearAll, this.clearAll);
        }else{
            $(document).on('click', this.el.ioc, function(e){
                if(!$(this).parent().hasClass('hx-result-type-open')){
                    $(this).parent().addClass('hx-result-type-open');
                    $(".hx-result-rby-return").show();
                };
            });
            $(document).on('click', this.el.mButton, function(){
                $('body,html').css('overflow', 'hidden');
                $(".hx-search-result-left-col-inner").addClass('hx-search-result-left-col-open');
            });
            $(document).on('click', this.el.tooClose, function(){
                $('body,html').css('overflow', 'visible');
                $(".hx-search-result-left-col-inner").removeClass('hx-search-result-left-col-open');
                $(".hx-search-result-left-col-inner .hx-result-type").removeClass('hx-result-type-open');
                $(".hx-result-rby-return").hide();
            });
            $(document).on('click', this.el.tooReturn, function(e){
                if($(".hx-result-type").hasClass('hx-result-type-open')){
                    $(".hx-result-type").removeClass('hx-result-type-open');
                    $(".hx-result-rby-return").hide();
                };
            });
            $(document).on('click', this.el.mClear, this.mClear);
            $(document).on('click', this.el.mClearAll, this.clearAll);
        };
        $(document).on('click', this.el.button, function(e){
            _this.checkboxChange($(this));
        });
        $(document).on('click', this.el.page, this.pagination);
        $(document).on('click', this.el.dropdown, this.dropdownfun);
        $(document).on('click', this.el.sortBy, function(e){
            if(!$(this).hasClass('hx-search-result-sort-by-open')){
                $(this).addClass('hx-search-result-sort-by-open');
                $(this).siblings(".hx-search-result-filter-dropdown").show();
            }else{
                $(this).removeClass('hx-search-result-sort-by-open');
                $(this).siblings(".hx-search-result-filter-dropdown").hide();
            };
            return false;
        });
        $(document).click(function(e){
            $(_this.el.sortBy).removeClass('hx-search-result-sort-by-open');
            $(_this.el.sortBy).siblings(".hx-search-result-filter-dropdown").hide();
        })
        window.addEventListener('pushState', function(e) {
            //监听 
        });
    };
    debounce = (fn) => {
        let timer = null;
        let dur = 400;
        return function(...args) {
            if(timer){
                clearTimeout(timer) ;
            };
            timer = setTimeout(()=>{
                fn.apply(this, args);
            },dur);
        };
    };
    dropdownfun = (e) => {
        let by = e.target.dataset.by;
        let sort = e.target.dataset.sort;
        let key = e.target.dataset.key;
        $(".hx-search-result-sort-by .sortby").html(key);
        let t_url = decodeURI(window.location.href);
        let param = 'pm_sort=' + sort + '-by' + by + '-by' + key;
        if (t_url.indexOf("?") > -1) {
            if(t_url.indexOf('pm_sort=') < 0){
                t_url += '&' + param;
            }else if(t_url.indexOf('pm_sort=') > -1){
                let _ps = t_url.split('&pm_sort=');
                if(_ps[1].indexOf('&') > -1){
                    let _tp = _ps[1].split('&');
                    let str = '';
                    _tp.forEach((item, key) => {
                        if(key == 0){
                            str += '&' + param;
                        }else{
                            str += '&' + item;
                        };
                    });
                    t_url = _ps[0] + str;
                }else{
                    t_url = _ps[0] + '&' + param;
                };
            };
        }else{
            t_url += '?' + param;
        };
        if(this._page == 2){
            t_url = t_url.replace('&page=2', '&page=1');
            this._page = 1;
        };
        this.initData(t_url);
        window.history.pushState({}, '', t_url);
    }
    checkboxChange = (e) => {
        if(!e.parent().hasClass('selected')){
            e.attr('hxcj-checked', true).parent().addClass('selected');
        }else{
            e.removeAttr('hxcj-checked').parent().removeClass('selected');
        };
        this.changeUrl(e.attr('data-param').toLowerCase(), e.attr('data-id'), e.attr('hxcj-checked'));
        // this.selectedChange();
    };
    _wrHistory = () => {
        const _wr = type => {
            const origin = history[type];
            return function() {
                const event = new Event(type);
                event.arguments = arguments;
                window.dispatchEvent(event);
                return origin.apply(this, arguments);
            };
        };
        history.pushState = _wr('pushState');
        history.replaceState = _wr('replaceState');
    };
    initSelectedData = (url = window.location.href) => {
        let obj = [];
        let index = url.indexOf('?');
        let params = url.substr(index + 1);
        if(index != -1) {
            let parr = params.split('&');
            parr.map((i)=>{
                let arr = i.split('=');
                if(i.indexOf('pm_') > -1){
                    let o = arr[0].replace('pm_', '');
                    let id = decodeURI(arr[1]);
                    let title = o.replace(/_/g, ' ');
                    let name = $('[data-id="' + decodeURI(arr[1]) + '"]').attr('data-val');
                    if(name){
                        obj.push({
                            id: id,
                            title: title,
                            name: name,
                        });
                    };
                    if(o == 'price'){
                        id = 'price_' + decodeURI(arr[1]);
                        title = 'price';
                        name = decodeURI(arr[1]);
                        if(decodeURI(arr[1]).indexOf('-') > -1){
                            this._min = decodeURI(arr[1]).split('-')[0];
                            this._max = decodeURI(arr[1]).split('-')[1];
                        }else{
                            this._min = decodeURI(arr[1]);
                            this._max = decodeURI(arr[1]);
                        };
                        obj.push({
                            id: id,
                            title: title,
                            name: name,
                        });
                    };
                };
            });
        };
        return obj;  
    };
    changeUrl = (pm, id, checked) => {
        console.log(this.selectedData, 55);
        console.log(pm, id, checked,66);
        let t_url = decodeURI(window.location.href);
        let param = pm + '=' + id;
        let name = $('[data-id="' + id + '"]').attr('data-val');
        if (t_url.indexOf("?") > -1) {
            if(t_url.indexOf(param) < 0 && checked){
                this.selectedData.push({
                    id: id,
                    title: pm,
                    name: name,
                });
                t_url += '&' + param;
            }else if(t_url.indexOf(param) > -1 && !checked){
                if(t_url.indexOf("&") > -1){
                    t_url = t_url.replace('&' + param, '');
                }else{
                    t_url = t_url.replace(param, '');
                };
                let ub = this.selectedData.filter(item=>item.id == 'id');
                let index = -1;
                if(ub.length > 0){
                    index = this.selectedData.indexOf(ub[0]);
                };
                if(index > -1){
                    this.selectedData.splice(index, 1);
                };
            };
        }else{
            t_url += '?' + param;
            this.selectedData.push({
                id: id,
                title: pm,
                name: name,
            });
        };
        if(pm == 'pm_color' && t_url.indexOf("pm_size") > -1){
            t_url = this.removeURLParameter(t_url, 'pm_size');
            let sd = [];
            this.selectedData.map((v)=>{
                if(v.title.toLowerCase() != 'pm_size' && v.title.toLowerCase() != 'size'){
                    sd.push(v);
                };
            });
            this.selectedData = sd;
        }
        if(pm == 'pm_size' && t_url.indexOf("pm_color") > -1){
            t_url = this.removeURLParameter(t_url, 'pm_color');
            let sd = [];
            this.selectedData.map((v)=>{
                if(v.title.toLowerCase() != 'pm_color' && v.title.toLowerCase() != 'color'){
                    sd.push(v);
                };
            });
            this.selectedData = sd;
        }
        if(this._page == 2){
            t_url = t_url.replace('&page=2', '&page=1');
            this._page = 1;
        };
        this.initData(t_url);
        window.history.pushState({}, '', t_url);
    };
    changeUrlPrice = (start, end) => {
        let t_url = decodeURI(window.location.href);
        let param = 'pm_price=' + start + '-' + end;
        let data = {
            id: 'price_' + start + '-' + end,
            title: 'price',
            name: start + '-' + end,
        };
        if(start==end){
            param = 'pm_price=' + start;
            data = {
                id: 'price_' + start,
                title: 'price',
                name: start,
            };
        };
        let flag = true;
        this.selectedData.map((v)=>{
            if(v.title == 'price'){
                v.id = data.id;
                v.name = data.name;
                flag = false;
            }
        })
        if(flag){
            this.selectedData.push(data);
        }
        this.refineByDiv(this.selectedData);
        if (t_url.indexOf("?") > -1) {
            if(t_url.indexOf('pm_price') < 0){
                t_url += '&' + param;
            }else if(t_url.indexOf('pm_price') > -1){
                let _ps = t_url.split('&pm_price=');
                if(_ps[1].indexOf('&') > -1){
                    let _tp = _ps[1].split('&');
                    let str = '';
                    _tp.forEach((item, key) => {
                        if(key == 0){
                            str += '&' + param;
                        }else{
                            str += '&' + item;
                        };
                    });
                    t_url = _ps[0] + str;
                }else{
                    t_url = _ps[0] + '&' + param;
                };
            };
        }else{
            t_url += '?' + param;
        };
        if(this._page == 2){
            t_url = t_url.replace('&page=2', '&page=1');
            this._page = 1;
        };
        this.initData(t_url);
        window.history.pushState({}, '', t_url);
    };
    changeUrlPage = (pm, id) => {
        let t_url = decodeURI(window.location.href);
        let param = pm + '=' + id;
        if (t_url.indexOf("?") > -1) {
            if(t_url.indexOf('page=') < 0){
                t_url += '&' + param;
            }else{
                if(t_url.indexOf("&") > -1){
                    t_url = t_url.replace('&page=' + this._page, '&' + param);
                }else{
                    t_url = t_url.replace('page=' + this._page, param);
                };
            };
        }else{
            t_url += '?' + param;
        };
        this._page = id;
        this.initData(t_url);
        window.history.pushState({}, '', t_url);
    };
    removeURLParameter(url, parameter) {
        var urlparts = url.split('?');
        if(urlparts.length >= 2) {
            //参数名前缀
            var prefix = encodeURIComponent(parameter) + '=';
            var pars = urlparts[1].split(/[&;]/g);
     
            //循环查找匹配参数
            for(var i = pars.length; i-- > 0;) {
                if(pars[i].lastIndexOf(prefix, 0) !== -1) {
                    //存在则删除
                    pars.splice(i, 1);
                }
            }
     
            return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
        }
        return url;
    };
    toggleEvent = (e) => {
        if(!e.hasClass('hx-block-title-active')){
            e.addClass('hx-block-title-active');
            e.siblings('.hx-result-rby-content').hide();
        }else{
            e.removeClass('hx-block-title-active');
            e.siblings('.hx-result-rby-content').show();
        };
    };
    selectedChange = () => {
        var data = [];
        $("[hxcj-checked=true]").each(function(index){
            if($(this).attr('data-id') && $(this).attr('data-tit') && $(this).attr('data-val')){
                data.push({
                    id: $(this).attr('data-id'),
                    title: $(this).attr('data-tit'),
                    name: $(this).attr('data-val'),
                });
            };
        });
        let price = this.selectedData.filter(item=>item.title == 'price');
        let index = -1;
        if(price.length > 0){
            index = this.selectedData.indexOf(price[0]);
        }
        this.selectedData = data;
        if(index > -1){
            this.selectedData.splice(index, 0, price[0]);
        }
        this.refineByDiv(data);
    };
    clear = (e) => {
        let id = e.target.dataset.id;
        let pm = e.target.dataset.param;
        let key = this.selectedData.indexOf(this.selectedData.filter(d=>d.id == id)[0]);
        this.selectedData.splice(key, 1);
        if(id.indexOf('price') == -1){
            $('[data-id="' + id + '"]').attr('hxcj-checked', false).parent().removeClass('selected');
        }else{
            id = id.replace('price_', '');
        };
        this.changeUrl(pm.toLowerCase(), id, false);
        // this.refineByDiv(this.selectedData);
    };
    clearAll = () => {
        this.selectedData = [];
        $("[hxcj-checked=true]").each(function(index){
            $(this).attr('hxcj-checked', false).parent().removeClass('selected');
        });
        let url = window.location.href.split('?');
        let parr = url[1].split('&');
        let arr = [];
        for(let i of parr) {  
            if(i.indexOf('pm_') == -1 || i.indexOf('pm_sort') > -1){
                arr.push(i);
            };
        };
        let turl = url[0] + arr.join('&');
        this.initData(turl);
        window.history.pushState({}, '', turl);
        this.refineByDiv(this.selectedData);
    };
    mClear = (e) => {
        let type = e.target.dataset.type;
        this.selectedData = [];
        $("[hxcj-checked=true]").each(function(index){
            $(this).attr('hxcj-checked', false).parent().removeClass('selected');
        });
        let url = window.location.href.split('?');
        let parr = url[1].split('&');
        let arr = [];
        for(let i of parr) {  
            if(i.indexOf('pm_' + type) == -1 || i.indexOf('pm_sort') > -1){
                arr.push(i);
            };
        };
        let turl = url[0] + arr.join('&');
        this.initData(turl);
        window.history.pushState({}, '', turl);
        this.refineByDiv(this.selectedData);
    };
    pagination = (e) => {
        let page = e.target.dataset.page;
        let t_url = decodeURI(window.location.href);
        $('body,html').animate({ scrollTop: 0 }, 500);
        this.changeUrlPage('page', page);
    };
    initSelecteds = (data = []) => {
        data.map((v, k)=>{
            if(v.name != 'price'){
                $('[data-id="' + v.id + '"]').attr('hxcj-checked', true).parent().addClass('selected');
            };
        });
    };
    refineByMobile = (data=[]) => {
        let product = [];
        let color = [];
        let size = [];
        let price_range = '';
        data.forEach((v, k)=>{
            if(v.title.indexOf('product') > -1){
                product.push(v.name);
            };
            if(v.title.indexOf('color') > -1){
                color.push(v.name);
            };
            if(v.title.indexOf('size') > -1){
                size.push(v.name);
            };
            if(v.title.indexOf('price') > -1){
                price_range = v.name;
            };
        });
        $('.hx-result-selected-items-price span').html(price_range);
        $('.hx-result-selected-items-product span').html(product.join(','));
        $('.hx-result-selected-items-color span').html(color.join(','));
        $('.hx-result-selected-items-size span').html(size.join(','));
    };
    priceEvent = (_min, _max) => {
        var _this = this;
        $("#hx-price-range").off("changed");
        $("#hx-price-range").slider({
            unit: "$",
            beyondMax: true,
            beyondMin: true,
            firstWidth: 34,
            lastWidth: 23,
            min: _min,
            max: _max,
        })
        .on("changed", _this.debounce(function(...arg) {
            let args = arg[1]
            var min = args.value.leftValue,
                max = args.value.rightValue;
            _this._min = min;
            _this._max = max;
            $("#hx-price-range").off("changed");
            _this.changeUrlPrice(min,max);
        }));
        $("#hx-price-range").data("slider").setRange({
            leftValue: _this._min || _min,
            rightValue: _this._max || _max,
        });
    };
    renders = () => {
        let price = this.priceDiv();
        let prod = this.productDiv(this.productData);
        let color = this.colorDiv(this.colorData);
        let size = this.sizeDiv(this.sizeData);
        let list = this.drawProduct(this.listProductData);
        let sort = this.sortDiv(this.sortData);
        let total = this.initDataObj.total;
        let str = `
            <div class="hx-search-result-container clearfix">
                <div class="hx-search-result-filter">
                    <div class="hx-search-result-left-col">
                        <div class="hx-search-result-left-col-inner">
                            <div class="hx-result-mobile-relative">
                                <div class="hx-result-mobile-toolbar">
                                    <div class="hx-result-mobile-toolbar-top">
                                        <div class="hx-result-toolbar-close">
                                            <span>Close</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="hx-result-refineBy"></div>
                                <div class="hx-result-mobile-toolbar-items">
                                    <div class="hx-result-mobile-toolbar-middle">filter</div>
                                    <div class="hx-result-mobile-toolbar-right">
                                        <a class="hx-result-mClearAll">clear all</a>
                                    </div>
                                </div>
                                <div class="hx-result-contents-type">
                                    <div class="hx-result-type">
                                        ${prod}
                                    </div>
                                    <div class="hx-result-type">
                                        ${color}
                                    </div>
                                    <div class="hx-result-type">
                                        ${size}
                                    </div>
                                    <div class="hx-result-type">
                                        ${price}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="hx-search-result-right-col">
                        <div class="hx-search-result-filter-toolbar-count">
                            <div class="hx-search-result-filter-toolbar-count-m">
                                <button class="hx-search-result-sort-by">
                                    <span><span class="sortby">${this._sortBy}</span></span>
                                </button>
                                <div class="hx-search-result-filter-dropdown">
                                    ${sort}
                                </div>
                                <div class="hx-search-mobile-button"><span> </span></div>
                            </div>
                            <span class="hx-search-result-toolbar-span">Showing <span class="hx-search-result-filter-toolbar-total">${total}</span> results</span>
                        </div>
                        <ul class="hx-grid">
                            ${list}
                        </ul>
                        <div class="hx-pagination"></div>
                    </div>
                </div>
            </div>
        `;
        $(this.el.main).html(str);
        document.title = `Search: Showing ${total} results`
        this.paginationHtml(this.initDataObj);
        this.selectedData = this.initSelectedData();
        this.initSelecteds(this.selectedData);
        this.refineByDiv(this.selectedData);
    };
    rendersStatic = () => {
        var that = this;
        let total = this.initDataObj.total;
        let list = this.drawProduct(this.listProductData);
        let prod = this.productfor(this.productData);
        let color = this.colorfor(this.colorData);
        let size = this.sizefor(this.sizeData);
        document.title = `Search: Showing ${total} results`
        $(".hx-search-result-right-col .hx-grid").html(list);
        $(".hx-search-result-filter-toolbar-total").html(total);
        $(".hx-result-rby-list-product").html(prod);
        $(".hx-result-rby-list-color").html(color);
        $(".hx-result-rby-list-size").html(size);
        this.paginationHtml(this.initDataObj);
        // this.selectedData = this.initSelectedData();
        this.initSelecteds(this.selectedData);
        this.refineByDiv(this.selectedData);
    };
    paginationHtml = (obj = {}) => {
        const { page, totalPage } = obj;
        let str = '';
        if(this.listProductData && this.listProductData.length){
            if(page == 1){
                str += `<div class="hx-pagination-list hx-pagination-list-disabled"><span>←</span></div>`;
            }else{
                str += `<div class="hx-pagination-list hx-pagination-list-page"><a data-page="1" title="Page Previous">←</a></div>`;
            };
            for(let i=0; i<totalPage; i++){
                if(page == i + 1){
                    str += `<div class="hx-pagination-list"><span class="hx-pagination-active">${i + 1}</span></div>`;
                }else{
                    str += `<div class="hx-pagination-list"><a data-page="${i + 1}" title="Page ${i + 1}">${i + 1}</a></div>`;
                };
            };
            if(page == totalPage){
                str += `<div class="hx-pagination-list hx-pagination-list-disabled"><span>→</span></div>`;
            }else{
                str += `<div class="hx-pagination-list hx-pagination-list-page"><a data-page="${totalPage}" title="Page Next">→</a></div>`;
            };
        };
        $(".hx-pagination").html(str);
    };
    refineByDiv = (data = []) => {
        if(!this.isMobile){
            let str = "";
            data.length && data.forEach((item, key) => {
                let pm = item.title && item.title.replace(' ', '_');
                pm = pm.indexOf('pm')>-1?pm:('pm_'+pm);
                str += `
                <div class="hx-result-rby-list-label">
                    <span class="rby-label">
                        <span>${item.title}</span>
                        <strong>${(item.title && item.title.toUpperCase()=='PRICE')?'$':''}${item.name}</strong>
                    </span>
                    <span class="rby-clear" data-param="${pm}" data-id="${item.id}"></span>
                </div>
                `;
            });
            let _html = `<div class="hx-result-rby-title">
                            <h3><span>Refine By</span></h3>
                            <a class="rby-clearAll">Clear</a>
                        </div>
                        <div class="hx-result-rby-content">
                            <div class="hx-result-rby-list">
                                ${str}
                            </div>
                        </div>`;
            $(".hx-result-refineBy").html(data.length?_html:'');
        }else{
            this.refineByMobile(data);
        }
    };
    priceDiv = () => {
        return `<div class="hx-result-rby-return"><span> </span></div>
                <div class="hx-result-rby-title hx-block-title-ioc">
                    <h3>
                        <span>Price</span>
                        <a class="hx-result-rby-clear" data-type="price">clear</a>
                    </h3>
                    <p class="hx-result-selected-items-mobile hx-result-selected-items-price"><span></span></p>
                </div>
                <div class="hx-result-rby-content">
                    <div id="hx-price-range" class="hx-price-range">
                        <div class="price-range-slider">
                            <div class="bg-darkgrey"></div>
                            <div class="bg-darkgrey-hand"></div>
                            <ul class="slider-ul">
                            </ul>
                        </div>
                        <div class="slide-selected"></div>
                        <i class="btn-price btn-left"></i>
                        <i class="btn-price btn-right"></i>
                        <div class="tip">
                            <div class="tip-content"></div>
                            <span class="tip-top tip-arrow"></span>
                        </div>
                    </div>
                </div>`;
    };
    productDiv = (data = []) => {
        let str = this.productfor(data);
        return `<div class="hx-result-rby-return"><span> </span></div>
                <div class="hx-result-rby-title hx-block-title-ioc">
                    <h3>
                        <span>Product type</span>
                        <a class="hx-result-rby-clear" data-type="product">clear</a>
                    </h3>
                    <p class="hx-result-selected-items-mobile hx-result-selected-items-product"><span></span></p>
                </div>
                <div class="hx-result-rby-content">
                    <div class="hx-result-rby-list hx-result-rby-list-product">
                        ${str}
                    </div>
                </div>`;
    };
    colorDiv = (data = []) => {
        let str = this.colorfor(data);
        return `<div class="hx-result-rby-return"><span> </span></div>
                <div class="hx-result-rby-title hx-block-title-ioc">
                    <h3>
                        <span>Color</span>
                        <a class="hx-result-rby-clear" data-type="color">clear</a>
                    </h3>
                    <p class="hx-result-selected-items-mobile hx-result-selected-items-color"><span></span></p>
                </div>
                <div class="hx-result-rby-content">
                    <div class="hx-result-rby-list hx-result-rby-list-color hx-result-rby-list-flex clearfix">
                        ${str}
                    </div>
                </div>`;
    };
    sizeDiv = (data = []) => {
        let str = this.sizefor(data);
        return `<div class="hx-result-rby-return"><span> </span></div>
                <div class="hx-result-rby-title hx-block-title-ioc">
                    <h3>
                        <span>Size</span>
                        <a class="hx-result-rby-clear" data-type="size">clear</a>
                    </h3>
                    <p class="hx-result-selected-items-mobile hx-result-selected-items-size"><span></span></p>
                </div>
                <div class="hx-result-rby-content">
                    <div class="hx-result-rby-list hx-result-rby-list-size hx-result-rby-list-flex clearfix">
                        ${str}
                    </div>
                </div>`;
    };
    sortDiv = (data = {}) => {
        let str = "";
        Object.keys(data).forEach(key => {
            str += `
            <div class="lst">
                <a data-key="${key}" data-by="${data[key].by}" data-sort="${data[key].sort}">${key}</a>
            </div>
            `;
        });
        return str;
    };
    productfor = (data = []) => {
        let str = "";
        data.length && data.forEach((item, index) => {
            str += `
            <div class="lst">
                <button class="hx-result-rby-button" data-tit="Product type" data-id="${item.id}" data-val="${item.title}" data-param="pm_product_type">
                    <span class="hx-rby-Checkbox"></span>
                    <span class="hx-rby-label">${item.title}（${item.product_count}）</span>
                </button>
            </div>
            `;
        });
        return str;
    };
    colorfor = (data = []) => {
        let str = "";
        data.length && data.forEach((item, index) => {
            let c = '';
            if(item.type == 2){
                c = `<span class="hx-rby-image" style="background: ${item.show_value}"></span>`;
            }else if(item.type == 1){
                c = `<span class="hx-rby-image" style="background-image: ${item.show_value?('url('+item.show_value+')'):'none'}"></span>`;
            }else{
                c = `<span class="hx-rby-image"></span>`;
            }
            str += `
            <div class="lst">
                <button class="hx-result-rby-button" data-tit="Color" data-id="${item.option_value_id}" data-val="${item.value}" data-param="pm_color">
                    ${c}
                    <p class="hx-rby-label ellipsis">${item.value}</p>
                </button>
            </div>
            `;
        });
        return str;
    };
    sizefor = (data = []) => {
        let str = "";
        data.length && data.forEach((item, index) => {
            str += `
            <div class="lst">
                <button class="hx-result-rby-button" data-tit="Size" data-id="${item.option_value_id}" data-val="${item.value}" data-param="pm_size">
                    <span class="hx-rby-size">${item.value}</span>
                </button>
            </div>
            `;
        });
        return str;
    };
    getParamsData = (url = window.location.href) => {
        let obj = {}, 
        index = url.indexOf('?'), 
        params = url.substr(index + 1);
        if(index != -1) {
            let parr = params.split('&');
            let collection_id = [];
            let option_value_ids = [];
            for(let i of parr) {
                let arr = i.split('=');
                if(arr[0] == 'q'){
                    obj.keyword = decodeURI(arr[1]);
                };
                if(arr[0] == 'page'){
                    obj.page = arr[1];
                    this._page = arr[1]
                }
                if(i.indexOf('pm_') > -1){
                    if(arr[0] == 'pm_product_type'){
                        collection_id.push(decodeURI(arr[1]));
                    };
                    if(arr[0] == 'pm_color' || arr[0] == 'pm_size'){
                        option_value_ids.push(decodeURI(arr[1]));
                    };
                    if(arr[0] == 'pm_price'){
                        obj.price_range = decodeURI(arr[1]);
                    };
                    if(arr[0] == 'pm_sort'){
                        let sorts = decodeURI(arr[1]);
                        obj.by = sorts.split('-by')[1];
                        obj.sort = sorts.split('-by')[0];
                        this._sortBy = sorts.split('-by')[2];
                    };
                };
            };
            obj.collection_id = collection_id.join(',');
            obj.option_value_ids = option_value_ids.join(',');
        };
        return obj;
    };
    initData = (url) => {
        let _this = this;
        let params = {};
        console.log(url, 666);
        params = this.getParamsData(url);
        $.ajax({
            url: hxAppConfig.api.productUrl,
            data: params,
            type:'GET',
            beforeSend: function (request) {
                request.setRequestHeader("mark", hxMark);
            },
            success: function(data){
                if(data.resultCode == 200){
                    _this.initDataObj = data.resultData;
                    _this.productData = data.resultData.collection;
                    _this.colorData = data.resultData.optionValue.Color;
                    _this.sizeData = data.resultData.optionValue.Size;
                    _this.sortData = data.resultData.sort;
                    let min = parseInt(data.resultData.price_range.min_price) || 1;
                    let max = parseInt(data.resultData.price_range.max_price);
                    _this.listProductData = data.resultData.data;
                    if(url){
                        _this.rendersStatic();
                    }else{
                        _this.renders();
                    }
                    // _this.renders();
                    setTimeout(function(){
                        _this.priceEvent(min, max);
                    }, 500)
                };
            },
            error: function(err){
                //alert(err)
            }
        })
    };
    drawProduct = (data = []) => {
        let str = '';
        data.length && data.forEach((item, index) => {
            str += this.hxPFSTemplate(this.templateHtmlType, item);
        });
        return str;
    };
    hxPFSTemplate = (layout, v) => {
        switch(layout){
            case 'productGridItemHtml': 
                return `<div class="grid__item">
                    <div class="card-wrapper">
                        <div class="card-information">
                            <div class="card-information__wrapper">
                            <div class="card-information__text">
                                <a href="${v.url}" class="full-unstyled-link">
                                ${v.title}
                                </a>
                            </div>
                                ${this.buildPrice(v)}
                            </div>
                        </div>
                        <div class="card card--product" tabindex="-1">
                            <div class="card__inner">
                                <div>
                                    <div 
                                        class="media media--transparent media--adapt media--hover-effect"
                                        style="padding-bottom: 133.33333333333331%"
                                    >
                                        <img class="motion-reduce" loading="lazy" src="${v.src}">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>`;
            default: 
                return '';
        };
    };
    buildPrice =(v) => {
		var html = '';
		html = `<div class="hx-price">
					<div>
						<div class="hx-price-sale">
							<span>
								<s class="hx-price-item-regular">
                                    $${Number(v.compare_at_price || 0).toFixed(2)}
								</s>
							</span>
							<span class="hx-price-item-sale">
                                $${Number(v.price || 0).toFixed(2)}
							</span>
						</div>
					</div>
				</div>`;
		return html;
	};
};